import React, { useEffect, useRef } from "react";
import { SpinnerIcon } from "@taskpane/icons";
import css from "./WizardMessage.module.scss";

export interface WizardMessageProps {
  content?: React.ReactNode;
  isLoading?: boolean;
  shoulScrollIntoView?: boolean;
}

const WizardMessage: React.FC<WizardMessageProps> = ({
  content,
  isLoading = false,
  shoulScrollIntoView = false,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const attrs = {
    container: {
      ref: containerRef,
      className: css.container,
    },
    spinnerIcon: {
      className: css.spinnerIcon,
    },
  };

  useEffect(() => {
    let timeout: number;

    if (shoulScrollIntoView && containerRef.current) {
      timeout = window.setTimeout(() => {
        containerRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 300);
    }

    return () => {
      window.clearTimeout(timeout);
    };
  }, [content, isLoading, shoulScrollIntoView]);

  return (
    <div {...attrs.container}>{isLoading ? <SpinnerIcon {...attrs.spinnerIcon} /> : content}</div>
  );
};

export default WizardMessage;
